module.exports = __webpack_public_path__ + "media/images/calendar_off-849ed2dda7b3a719fce1bf18f6d142c4.png";